import React, { ReactNode, useMemo } from 'react'
import { Divider, Layout, Modal } from '@ui-kitten/components'
import { View, ViewStyle } from 'react-native'
import { BtSubTitle } from './BtText'

interface Props {
  title?: string | ReactNode
  footer?: ReactNode
  children: any
  onBackdropPress?: () => void
  onClose?: () => void
  visible: boolean
  containerStyle?: ViewStyle
  showDivider?: boolean
  customHeader?: ReactNode
}

export const BtModal = ({
  title,
  footer,
  children,
  onBackdropPress,
  visible = false,
  onClose,
  containerStyle,
  showDivider = true,
  customHeader,
}: Props) => {
  const _header = useMemo(() => {
    if (customHeader) return null
    if (!title) return null
    if (typeof title === 'string') {
      return (
        <View style={{ padding: 20 }}>
          <BtSubTitle>{title}</BtSubTitle>
        </View>
      )
    }
    return <View style={{ padding: 13 }}>{title}</View>
  }, [customHeader, title])

  return (
    <Modal
      visible={visible}
      onBackdropPress={onBackdropPress || onClose}
      backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
    >
      <Layout style={{ borderRadius: 8 }}>
        {customHeader}
        {_header}
        {!!_header && <Divider />}
        <View style={[{ padding: 20, flex: 1 }, containerStyle]}>
          {children}
        </View>
        {!!footer && (
          <View>
            {showDivider && <Divider />}
            <View style={{ padding: 20 }}>{footer}</View>
          </View>
        )}
      </Layout>
    </Modal>
  )
}
